import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }

  setToken(token: string) {
    sessionStorage.setItem('token', token);
  }

  getToken(): string {
    return sessionStorage.getItem('token') || sessionStorage.getItem('token') || '';
  }

  setUserData(data: any, isInsessionStorage: boolean = true) {
    if (isInsessionStorage) {
      sessionStorage.setItem('userData', JSON.stringify(data));
    } else {
      sessionStorage.setItem('userData', JSON.stringify(data));
    }
  }

  getUserData(): any {
    return JSON.parse(sessionStorage.getItem('userData') as any) || JSON.parse(sessionStorage.getItem('userData') as any);
  }

  setUserRole(data: any,) {
    sessionStorage.setItem('role', data);
  }

  getUserRole(): any {
    return sessionStorage.getItem('role') || sessionStorage.getItem('role') || '';
  }

  logout(): void {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('role');
  }
}
